import axios from "axios";

let apiConfig = {
	userId: '',
	clientId: ''
};

const initAPIs = (userId: any, clientId: string) => {
	apiConfig.userId = userId;
	apiConfig.clientId = clientId;
};

const AxiosAPI = axios.create({
	baseURL: process.env.REACT_APP_NEW_WEB_API,
	headers: {
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
		'Accept': 'application/json',
	}
});

AxiosAPI.interceptors.request.use((config) => {
    config.withCredentials = true; 
    config.headers['X-Client-ID'] = apiConfig.clientId;
    return config;
});

AxiosAPI.interceptors.response.use(undefined, (error) => {
	if (error?.response?.status === 401) {
		window.location.href = '/login';
	}
	return error;
});


export { initAPIs, AxiosAPI };